<template>
  <!-- Footer -->
  <footer class="text-center text-lg-start bg-light text-muted">
    <!-- Section: Social media -->
    <section class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
      <!-- Left -->
      <div class="me-5 d-none d-lg-block">
        <span>Get connected with us on social networks:</span>
      </div>
      <!-- Left -->

      <!-- Right -->
      <div>
        <a href="https://www.facebook.com/SimplexityDynamics/" class="me-4 text-reset">
          <i class="fab fa-facebook-f"></i>
        </a>
        <a href="https://twitter.com/DSimplexity" class="me-4 text-reset">
          <i class="fab fa-twitter"></i>
        </a>
        <a href="https://www.instagram.com/simplexitydynamics/" class="me-4 text-reset">
          <i class="fab fa-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/company/simplexity-dynamics" class="me-4 text-reset">
          <i class="fab fa-linkedin"></i>
        </a>
        <a href="https://www.youtube.com/@SimplexityDynamics" class="me-4 text-reset">
          <i class="fab fa-youtube"></i>
        </a>
      </div>
      <!-- Right -->
    </section>
    <!-- Section: Social media -->

    <!-- Section: Links  -->
    <section class="">
      <div class="container text-center text-md-start mt-5">
        <!-- Grid row -->
        <div class="row mt-3">
          <!-- Grid column -->
          <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
            <!-- Content -->
            <h6 class="text-uppercase fw-bold mb-4">
              <i class="fas fa-gem me-3"></i>The Founders
            </h6>
            <p >
                  

                  <a
                    class="btn btn-outline-light btn-lg m-2"
                    href="https://nz.linkedin.com/in/regieercilla"
                    role="button"
                    target="_blank" rel="noreferrer noopener"
                    >Regie</a
                  > 
                  and
                  <a
                    class="btn btn-outline-light btn-lg m-2"
                    href="https://www.linkedin.com/in/anneercilla/"
                    role="button"
                    target="_blank" rel="noreferrer noopener"
                    >Anne</a
                  >
                </p>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <!-- Links -->
          <!--div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
            
            <h6 class="text-uppercase fw-bold mb-4">
              Products
            </h6>
            <p>
              <a href="#!" class="text-reset">123</a>
            </p>
            <p>
              <a href="#!" class="text-reset">456</a>
            </p>
            <p>
              <a href="#!" class="text-reset">789</a>
            </p>
            <p>
              <a href="#!" class="text-reset">345</a>
            </p>
          </div-->
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">
              Other Works
            </h6>
            <p>
              <a href="https://codersinaction.com/" class="text-reset" target="_blank" rel="noreferrer noopener">Coders in Action</a>
            </p>
            <p>
              <a href="https://coolgrabs.com/" class="text-reset" target="_blank" rel="noreferrer noopener">Cool Grabs</a>
            </p>
            <p>
              <a href="https://stateoforder.com/" class="text-reset" target="_blank" rel="noreferrer noopener">State of Order</a>
            </p>
            <p>
              <a href="https://tychenet.com/" class="text-reset" target="_blank" rel="noreferrer noopener">Tyche Net</a>
            </p>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4"><i class="fas fa-home me-3"></i>Contact</h6>
            <p> 
              Simplexity Dynamics <br/> 
              Level 2 Bell Gully Building<br/>
              40 Lady Elizabeth Lane, Wellington 6011
            </p>
            
            
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </div>
    </section>
    <!-- Section: Links  -->

    <!-- Copyright -->
    <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05);">
      © 2023 Copyright:
      <a class="text-reset fw-bold" href="https://simplexitydynamics.com/">
        Simplexity Dynamics
      </a>
    </div>
    <!-- Copyright -->
  </footer>
  <!-- Footer -->

</template>

<script>
export default {
  name: 'NavFooter',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
